import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlertTrendRegisterDataAssetDashboard } from '../services/getAlertTrendRegisterData'

export interface AlertTrendRegisterDataState {
  isLoading: boolean
  errorMessage: string | null
  AlertTrendRegisterDataAssetDashboard: AlertTrendRegisterDataAssetDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: AlertTrendRegisterDataState = {
  AlertTrendRegisterDataAssetDashboard: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AlertTrendRigisterGraphDataState = createSlice({
  name: 'AlertTrendKPIDataAssetGraphData',
  initialState,
  reducers: {
    AlertTrendRegisterDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AlertTrendRegisterDataAssetDashboard: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AlertTrendRegisterDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AlertTrendRegisterDataAssetDashboard: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertTrendRegisterDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AlertTrendRegisterDataAssetDashboard: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AlertTrendRegisterDataLoadingAction,
  AlertTrendRegisterDataUpdateAction,
  AlertTrendRegisterDataErrorAction
} = AlertTrendRigisterGraphDataState.actions

export default AlertTrendRigisterGraphDataState.reducer
